// src/components/CustomLoader.js
import React from 'react';
import './CustomLoader.css'; // Import the custom loader CSS

const CustomLoader = () => {
  return (
    <div className="loader-container">
      <div className="custom-loader"></div>
    </div>
  );
};

export default CustomLoader;
